import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import type { FC } from 'react';
import { HorizontalSeparator, SectionHeaderTitle, SeparatorWrapper } from './ShipmentSeparator.styles';

type TSeparatorType =
  | 'Delivered'
  | 'RecentlyAdded'
  | 'Past'
  | 'ArrivingToday'
  | 'ArrivingTomorrow'
  | 'ArrivingThisWeek'
  | 'ArrivingSoon'
  | 'PendingDeliveryDate';

const SeparatorTitle: Record<TSeparatorType, MasterTranslation> = {
  RecentlyAdded: MasterTranslation.RecentlyAddedSeparator,
  Past: MasterTranslation.PastSeparator,
  Delivered: MasterTranslation.DeliveredSeparator,
  ArrivingToday: MasterTranslation.ArrivingTodaySeparator,
  ArrivingTomorrow: MasterTranslation.ArrivingTomorrowSeparator,
  ArrivingThisWeek: MasterTranslation.ArrivingThisWeekSeparator,
  ArrivingSoon: MasterTranslation.ArrivingSoonSeparator,
  PendingDeliveryDate: MasterTranslation.PendingDeliveryDateSeparator,
};

interface ShipmentSeparatorProps {
  color?: 'grey' | 'orange';
  type: TSeparatorType;
  id?: string;
}

export const ShipmentSeparator: FC<ShipmentSeparatorProps> = ({ id, color, type }) => {
  const { t } = useGlobalState();

  return (
    <SeparatorWrapper id={id}>
      <SectionHeaderTitle color={color}>{t(SeparatorTitle[type])}</SectionHeaderTitle>
      <HorizontalSeparator color={color} />
    </SeparatorWrapper>
  );
};
